import { Step } from 'react-joyride';

const getClientsTourSteps = (
  isMobile: boolean,
  hayRecientes: boolean
): Step[] => {
  const suffix = isMobile ? '-mobile' : '-desktop';

  const allSteps: (Step & { needsRecientes?: boolean; desktopOnly?: boolean })[] = [
    {
      target: '.tour-title',
      content: (
        <div style={{ textAlign: 'justify' }}>
          Bienvenido a <strong>Clientes</strong>. Aquí gestionas las personas
          asociadas a tu empresa: puedes añadirlas, buscarlas, consultar su
          última cita o eliminarlas.
        </div>
      ),
      placement: 'bottom',
      disableBeacon: true,
    },
    {
      target: '.tour-recientes',
      content: (
        <div style={{ textAlign: 'justify' }}>
          Estos son los <strong>clientes recientes</strong>: personas que han
          reservado contigo pero que aún no están en tu lista oficial. Pulsa{' '}
          <strong>Añadir</strong> para incorporarlos y tenerlos a mano.
        </div>
      ),
      placement: 'top',
      disableBeacon: true,
      needsRecientes: true,
    },
    {
      target: '.tour-filter-input',
      content: (
        <div style={{ textAlign: 'justify' }}>
          Usa esta barra para <strong>buscar un cliente</strong> por nombre,
          correo o teléfono. Muy útil cuando la lista empieza a crecer.
        </div>
      ),
      placement: 'bottom',
      disableBeacon: true,
    },
    {
      target: '.tour-add-btn',
      content: (
        <div style={{ textAlign: 'justify' }}>
          Pulsa <strong>Añadir cliente</strong> para incorporar uno nuevo. Si
          esa persona ya tiene cuenta en Bookoll, se vinculará a tu empresa por
          su correo.
        </div>
      ),
      placement: 'left',
      disableBeacon: true,
    },
    {
      target: '.tour-table-head',
      content: (
        <div style={{ textAlign: 'justify' }}>
          Esta es tu <strong>lista de clientes</strong>. Ves su nombre, correo,
          teléfono y la fecha de su última cita. Haz clic en cualquier cabecera
          de columna para <strong>ordenar</strong> la lista.
        </div>
      ),
      placement: 'top',
      disableBeacon: true,
      desktopOnly: true,
    },
    {
      target: `.tour-delete-btn${suffix}`,
      content: (
        <div style={{ textAlign: 'justify' }}>
          Pulsa la <strong>papelera </strong> para quitar un cliente de tu
          empresa. Te pedirá confirmación antes de hacerlo. Esto solo lo
          desvincula de tu negocio; su cuenta y su historial de citas no se
          borran.
        </div>
      ),
      placement: 'left',
      disableBeacon: true,
    },
    {
      target: '.tour-pagination',
      content: (
        <div style={{ textAlign: 'justify' }}>
          Si tienes muchos clientes, usa la <strong>paginación</strong> para
          moverte entre páginas y ajustar cuántos ver a la vez.
        </div>
      ),
      placement: 'top',
      disableBeacon: true,
    },
  ];

  return allSteps
    .filter((s) => !(s.needsRecientes && !hayRecientes))
    .filter((s) => !(isMobile && s.desktopOnly))
    .map(({ needsRecientes, desktopOnly, ...step }) => step);
};

export default getClientsTourSteps;